<template>
  <div class="lists-wrap group">
    <div class="header group">
      <div class="header-menu pure-menu pure-menu-horizontal group">
        <router-link to="/" class="pure-menu-heading home-link" v-on:click.native="homeClick()"><i class="fal fa-home"></i> Matrix</router-link>
        <ul class="pure-menu-list main-menu">
          <li class="pure-menu-item pure-menu-has-children pure-menu-allow-hover account-menu-item"><a href="#" v-on:click.stop.prevent="menuOpenClick" class="pure-menu-link"><i class="fas fa-bars"></i></a>
            <ul class="pure-menu-children">
              <li class="pure-menu-item"><router-link to="/lists" class="pure-menu-link">Lists</router-link></li>
              <li class="pure-menu-item"><router-link to="/account" class="pure-menu-link">Account</router-link></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <div class="lists-heading group section-panel">
      <h3>{{listName}}</h3>
      <router-link to="/Lists"><i class="fas fa-arrow-left"></i></router-link>
    </div>
    <ul class="movies-list">
      <li v-for="film in movies" :data-id="film.objectID" class="section-panel">
        <MoviePanel :movieData="film" :isList="true" />
      </li>
    </ul>
  </div>
</template>

<script>
  /* global mixpanel */
  import firebase from 'firebase'
  import Router from '../router'
  import db from './firebaseInit'
  import MoviePanel from './MoviePanel.vue'

  export default {
    name: 'List',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'List'
    },
    data: function () {
      return {
        currentUserID: this.$globals.currentUserID,
        listName: '',
        movies: [],
        movieIDs: [],
        noMovies: false
      }
    },
    created () {
      let vm = this
      this.getList()
      firebase.auth().onAuthStateChanged(function (user) {
        vm.user = null
        vm.name = ''
        vm.email = ''
        vm.photo = ''
        vm.userId = ''
        if (user) {
          vm.currentUserID = user.uid
          vm.$globals.currentUserID = user.uid
        }
      })
    },
    methods: {
      homeClick: function () {
        this.$eventHub.$emit('navigate-home')
      },
      menuOpenClick: function () {

      },
      getList: function () {
        let vm = this
        vm.movieIDs = []
        vm.movies = []
        var listsRef = db.collection('lists').doc(vm.$route.params.id)
        listsRef.get().then(function (doc) {
          if (doc.exists) {
            vm.listName = doc.data().name
            let movies = doc.data().films
            for (var i = 0; i < movies.length; i++) {
              vm.movieIDs.push(movies[i])
            }
            if (vm.movieIDs.length == 0) {
              vm.noMovies = true
            } else {
              vm.noMovies = false
              vm.getMovies()
            }
          }
        })
      },
      getMovies: function () {
        console.log('get movies')
        let vm = this
        var i = 0
        this.movieIDs.forEach(movieID => {
          db.collection('movies').where('id', '==', movieID).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              // console.log('fetch: ' + doc.id, ' => ', doc.data())
              var movieData = doc.data()
              movieData.docID = doc.id
              this.movies.push(movieData)
            })
          })
          i++
          // if (i == this.movieIDs.length) {
          //   setTimeout(function() {
          //     if (vm.grapeID && $('#grape-' + vm.grapeID).length > 0) {
          //       console.log('here: ' + vm.grapeID)
          //       $('html, body').animate({ scrollTop: $('#grape-' + vm.grapeID).offset().top }, 'slow')
          //     }
          //   }, 2000)
          // }
        })
      }
    },
    components: {
      MoviePanel
    }
  };
</script>

<style lang="scss" scoped>
  .section-panel {
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    margin: 0 5px 5px;
  }
  .lists-wrap {
    padding-top: 0;
    width: 100%;
    max-width: 400px;
    text-align: left;
    margin: 0 auto;
    background: #EFF3F7;
  }

  .header {
    margin: 5px;
  }

  .header-menu {
    background: rgb(41,100,134);
    background: -webkit-gradient(linear, left top, right top, from(rgba(41,100,134,1)), to(rgba(49,129,174,1)));
    background: linear-gradient(90deg, rgba(41,100,134,1) 0%, rgba(49,129,174,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#296486",endColorstr="#3181ae",GradientType=1);
    color: #fff;
    box-sizing: border-box;
    
    .pure-menu-heading {
      color: #fff;
      padding: 15px;
      font-size: 20px;
      float: left;
      text-transform: none;
      font-weight: bold;

      i {
        font-weight: normal;
        margin-right: 10px;
      }
    }
    .pure-menu-list {
      float: right;
      margin: 5px;
    }
    .pure-menu-list > .pure-menu-link {
      color: #fff;
      padding: 10px 18px;
      font-size: 20px;
    }
    .pure-menu-list .pure-menu-link:hover {
      color: #296486;
      background-color: #fff;
    }
  } /* end .header-menu */

  .lists-heading {
    text-align: left;

    h3 {
      margin: 10px 0;
      float: left;
      max-width: 80%;
    }

    a {
      color: #2C3E50;
      display: block;
      float: right;
      padding: 10px;
      margin: 2px 0;
    }

  }

  .user-lists-wrap {
    padding: 0 25px;
  }

  .movies-list {
    list-style: none;
    margin: 0;
    padding: 0
  }
</style>

<style scoped>
.pure-menu-list.main-menu {
  float: right;
  margin: 5px 5px 0 0;
  font-size: 20px;
}
.pure-menu-list.main-menu > .pure-menu-item > a {
  cursor: default;
  color: #fff;
}
.pure-menu-list.main-menu .pure-menu-children {
  left: auto;
  right: 0;
  top: 46px;
  box-shadow: 0px 0px 10px -3px rgba(0,0,0,0.5);
}
.pure-menu-list.main-menu .pure-menu-children > .pure-menu-item {
  border-top: 1px solid #eaeaea;
}
.pure-menu-list.main-menu .pure-menu-children > .pure-menu-item:first-child {
  border-top-width: 0;
}
.pure-menu-list.main-menu .pure-menu-children .pure-menu-link {
  font-size: 16px;
  padding: 1em 1.3em;
}
..pure-menu-list.main-menu .pure-menu-link {
  color: #fff;
  padding: 13px 18px;
}
.pure-menu-list.main-menu .pure-menu-item:hover > .pure-menu-link {
  color: #296486;
  background-color: #fff;
}
.pure-menu-has-children>.pure-menu-link:after {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/List.vue